module.exports = __webpack_public_path__ + "0cf70062c853084bb0171d2881db02e0.svg";